import { ListView, Icon, WingBlank, Pagination} from 'antd-mobile';
//import { StickyContainer, Sticky } from 'react-sticky';
import './News.css';
import CONF_LAN from "./config/LAN";
import BackToTopComp from './_components/backtotop';
class NewsComp extends React.Component {
    constructor(props) {
        super(props);
        const{data:{
            data,
            NewsDataBlob,
            NewsSectionIds,
            NewsRowIds
        }}=this.props;
        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];

        const dataSource = new ListView.DataSource({
            getRowData,
            getSectionHeaderData: getSectionData,
            rowHasChanged: (row1, row2) => row1 !== row2,
            sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });

        this.state = {
            dataSource,
            isLoading: true,
        };
    }

    componentDidMount() {
        const{data:{
            data,
            NewsDataBlob,
            NewsSectionIds,
            NewsRowIds
        }}=this.props;
        this.setState({
            dataSource: this.state.dataSource.cloneWithRowsAndSections(NewsDataBlob, NewsSectionIds, NewsRowIds),
            isLoading: false,
        });
    }

    // If you use redux, the data maybe at props, you need use `componentWillReceiveProps`
    // componentWillReceiveProps(nextProps) {
    //   if (nextProps.dataSource !== this.props.dataSource) {
    //     this.setState({
    //       dataSource: this.state.dataSource.cloneWithRowsAndSections(nextProps.dataSource),
    //     });
    //   }
    // }

    onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        if (this.state.isLoading && !this.state.hasMore) {
            return;
        }
        console.log('reach end', event);
        this.setState({ isLoading: true });
        setTimeout(() => {
            genData(++pageIndex);
            this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(NewsDataBlob, NewsSectionIds, NewsRowIds),
                isLoading: false,
            });
        }, 1000);
    }
    onNewsMore=()=>{
        if(!this.props.titlenourl){
            //window.open(this.props.moreurl);
            window.location.href=(this.props.moreurl);
        }

    }
    showNewsDetail=(e)=>{
        let url=$(e.target).attr('data-url')||$(e.currentTarget).attr('data-url');
        //window.open(this.props.newsdetailurl+'?url='+encodeURI(decodeURI(url)));
        window.location.href=(this.props.newsdetailurl+'?url='+encodeURI(decodeURI(url)));
    }
    render() {
        const separator = (sectionID, rowID) => (
            <div className={'news-separator'}
                key={`${sectionID}-${rowID}`}
                style={{

                }}
            />
        );
        //let index = data.length - 1;
        let index = 0;
        const{data:{
            data,
            newsBase
        }}=this.props;
        const row = (rowData, sectionID, rowID) => {
            if (index >=data.length) {
                index = data.length - 1;
            }
            const obj = data[index];
            index++;
            return (
                <div className={'news-line'} key={rowID} style={{ padding: '5px 0','margin':'0 15px' }}>
                    <div className={'news-title'}
                        style={{
                            lineHeight: '0.6rem',
                            color: '#000000',
                            fontSize: '0.37rem',
                        }}
                    ><a className={'news-a'} onClick={this.showNewsDetail} data-url={obj.url} data-href={newsBase+obj.url}>{obj.title}</a></div>
                    <div className={'news-date'}
                        style={{

                        }}
                    >{obj.date.substr(5)}</div>

                </div>
            );
        };
        let titleImg=this.props.titleimg;
        if(!titleImg){
            titleImg=CONF_LAN[CUR_LAN]['img_dir']+'News_title.png';
        }
        return (
            //<WingBlank size="sm">
            <ListView
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}
                className="am-list sticky-list"
                useBodyScroll
                renderSectionWrapper={sectionID => (
                    <div
                        key={`s_${sectionID}_c`}
                        className="sticky-container"
                        style={{ zIndex: 4 }}
                    >
                    </div>
                )}
                renderSectionHeader={sectionData => (
                    <div>
                        <div
                            className="sticky news-sticky"
                            style={{
                                zIndex: 3,

                                color: 'white',
                            }}
                        >
                            <img onClick={this.onNewsMore} className={'title-img news-title-img'} src={titleImg} />
                        </div>
                    </div>
                )}
                //renderHeader={() => <span>header</span>}
                //renderFooter={() => (<div style={{ padding: 30, textAlign: 'center' }}>
                //    {this.state.isLoading ? 'Loading...' : 'Loaded'}
                //</div>)}
                renderRow={row}
                pageSize={4}
                onScroll={() => { console.log('scroll'); }}
                scrollEventThrottle={200}
                //onEndReached={this.onEndReached}
                //onEndReachedThreshold={10}
            >
                <BackToTopComp img={BASE_MOBILE_ROOT+'img/common/top_white.png'}/>
            </ListView>
            //</WingBlank>
        );
    }
}
export default  NewsComp;